import React from "react"

const BulletPoints = () => (
    <section className="jl-HIWcandidateRequirements">
        <div className="row">
            <h1 className="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-8 offset-1 header">
                Why Sell to <span className="nowrap">Jiffy Lube</span>?
            </h1>
        </div>
        <div className="row">
            <div className="col-lg-8 offset-lg-2 col-md-12">
                <div className="row">
                    <div className="col-lg-4 col-md-12 col-sm-12 whiteBlock">
                        <h2 className="blockHeader">Fast Closing</h2>
                        <ul className="goldCircle">
                            <li>
                                <span className="bulletText">Confidentiality Assured</span>
                            </li>
                            <li>
                                <span className="bulletText">All Cash Transaction</span>
                            </li>
                            <li>
                                <span className="bulletText">Experienced Buyers to Assist with the Sale</span>
                            </li>
                        </ul>
                    </div>                    
                    <div className="col-lg-4 col-md-12 col-sm-12 whiteBlock">
                        <h2 className="blockHeader">Employee Retention</h2>
                        <ul className="goldCircle">
                            <li>
                                <span className="bulletText">Competitive Salary and Benefits</span>
                            </li>
                            <li>
                                <span className="bulletText">Opportunity for Advancement</span>
                            </li>
                            <li>
                                <span className="bulletText">Customer Care Top of Mind</span>
                            </li>
                        </ul>
                    </div>
                    <div className="col-lg-4 col-md-12 col-sm-12 whiteBlock">
                        <h2 className="blockHeader">Store Requirements</h2>
                        <ul className="goldCircle">
                            <li>
                                <span className="bulletText">Quick Lube Building with Basement</span>
                            </li>
                            <li>
                                <span className="bulletText">2 or more Drive-thru Service Bays</span>
                            </li>
                            <li>
                                <span className="bulletText">Customer Lobby and Restroom</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-md-12 text-center">
                <a href="#jl-contact-form" className="nav-link nav-link-cta js-scroll-trigger">
                    CONTACT US
                </a>
            </div>
        </div>
    </section>
)

export default BulletPoints